import React, { useState } from 'react';
import { func, object } from 'prop-types';

import {connect} from 'react-redux';

import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

import * as ServiceManagementActions from '../../../actions/serviceManagementActions';

import classes from './ContextMenu.module.css';

const AppointmentContextMenu = ({
    activeItem,
    appointment,
    onDeleteModalOpen,
    onManageAppointmentModalOpen,
    sendAppointmentNotification,
    setAppointmentActive,
    ...props
}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    function handleOpen(event) {
        setAnchorEl(event.currentTarget);
        setAppointmentActive(appointment);
    }

    function handleClose() {
        setAnchorEl(null);
    }

    function handleSendCommunication() {
        const { id } = appointment;

        sendAppointmentNotification(id);

        handleClose();
    }

    function handleManageAppointment() {
        onManageAppointmentModalOpen(true);

        handleClose();
    }

    function handleDeleteServiceCall() {
        if (activeItem.locked) return;

        onDeleteModalOpen(true);

        handleClose();
    }

    return (
        <React.Fragment>
            <Button
                aria-owns={open ? 'render-props-menu' : undefined}
                aria-haspopup="true"
                onClick={handleOpen}
                className={classes.contextMenuButton}
            >
                <i className="fas fa-ellipsis-h" />
            </Button>
            <Menu
                id="render-props-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                className={classes.contextMenu}
            >
                {
                    process.env.advancedCommEnabled &&
                    <MenuItem onClick={handleSendCommunication}>
                        <img
                            alt="send communication icon"
                            className={classes.contextIcon}
                            src="/assets/images/sendCommunicationIconColor.svg"
                        />
                        Send Communication
                    </MenuItem>
                }
                <MenuItem onClick={handleManageAppointment}>
                    <img
                        alt="manage appointment icon"
                        className={classes.contextIcon}
                        src="/assets/images/SettingsFlat.svg"
                    />
                    Manage
                </MenuItem>
                <MenuItem
                    onClick={handleDeleteServiceCall}
                    classes={{
                        root: activeItem.locked ? classes.disabled : ''
                    }}
                >
                    <img
                        alt="delete icon"
                        className={classes.contextIcon}
                        src="/assets/images/deleteIconColor.svg"
                    />
                    Delete
                </MenuItem>
            </Menu>
        </React.Fragment>
    );
};

AppointmentContextMenu.defaultProps = {
    activeItem:                   {},
    appointment:                  {},
    onDeleteModalOpen:            () => {},
    onManageAppointmentModalOpen: () => {}
};

AppointmentContextMenu.propTypes = {
    activeItem:                   object,
    appointment:                  object,
    onDeleteModalOpen:            func,
    onManageAppointmentModalOpen: func
};

const mapDispatchToProps = {
    ...ServiceManagementActions
};

export default connect(null, mapDispatchToProps)(AppointmentContextMenu);
